import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import Logo from "components/Logo/Logo";
import SocialsList from "components/SocialsList/SocialsList";
import { CustomLink } from "data/types";
import { Link } from "react-router-dom";
import GoogleAdModal, {GoogleAdHandle} from "components/GenericAd/AdComponent";
import { AdSlots, type AdType } from "components/GenericAd/adConfig";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const Footer: React.FC = () => {
 const adRef = useRef<GoogleAdHandle>(null);
const history = useHistory();

const handleAdNavigation = async (
e: React.MouseEvent<HTMLAnchorElement>,
slotKey: AdType,
) => {
e.preventDefault();

const config = AdSlots[slotKey];
if (!config) return;

try {
if (config.kind === "modal") {
await Promise.race([
adRef.current?.showAds(slotKey),
new Promise<void>((resolve) => setTimeout(resolve, 800)),
]);
}
} catch (error) {
console.error("Ad error:", error);
} finally {
if (config.route) {
history.push(config.route);
}
}
};

  return (
    <footer className="nc-Footer">
      <GoogleAdModal ref={adRef} />
      <div className="container py-5 relative flex border-t justify-between items-center space-x-4 xl:space-x-8">
       <div className="flex flex-col xl:flex-row items-center xl:items-start space-y-4 xl:space-y-0 xl:space-x-12 w-full ">
          
            <Logo height="50" width="300" />
            <div className="mt-2 flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-8">
            <Link
             aria-label="Contact Us"
             to={"/contact"} 
             className="lg:flex lg:flex-wrap cursor-pointer flex items-center font-italic text-md dark:text-neutral-200 ">
              Contact Us
            </Link>
            <Link
              aria-label="Guidelines"
              to={"/guidelines"}
              onClick={(e) => handleAdNavigation(e, "guidelines")}
              className="lg:flex lg:flex-wrap cursor-pointer  hover:font-semibold  flex items-center font-italic text-md dark:text-neutral-200 "
            >
              Guidelines
              </Link>
            <Link
             aria-label="Privacy Policy"
             to={"/privacy-policy"} 
             className="lg:flex lg:flex-wrap cursor-pointer hover:font-semibold flex items-center font-italic text-md dark:text-neutral-200 ">
             Privacy Policy
            </Link>
            <Link
             aria-label="Terms and Conditions"
             to={"/terms-conditions"} 
             className="lg:flex lg:flex-wrap cursor-pointer  hover:font-semibold  flex items-center font-italic text-md dark:text-neutral-200 ">
             Terms & Conditions
            </Link>
            </div>
            
     <div className="hidden sm:block h-7 mt-4 border-l border-neutral-300 dark:border-neutral-6000"></div>
          <div className="flex items-center ">
            <SocialsList className="text-3xl  flex items-center space-x-8 lg:items-start" />
          </div>
        </div>
      </div>
      <div className="container py-5 relative flex border-t justify-center items-center space-x-4 xl:space-x-8">
       <div className="flex justify-center items-center  space-y-4 xl:space-y-0 xl:space-x-12 w-full ">
            <div className="mt-2 flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-8">
            <div
              className="lg:flex lg:flex-wrap flex items-center font-italic text-md dark:text-neutral-200 ">
              © 2026 DZ Insights (OPC) Private Limited | CIN: U58201RJ2025OPC103837
            </div>
          </div>
        </div>
        </div>
    </footer>
  );
      };

export default Footer;

